<template>
  <main-layout>
    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-103"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title"> {{$t('label.router.reserveOptionSite')}}</label>
        <button-index slot="cancel" @click="commonOptionEdit" :disabled="!clickFlag" v-auth="{ auth: '010318'}">
          {{ $t('label.system.option.commonEdit') }}
        </button-index>
        <narrow-down slot="create" @click="createOption" v-auth="{ auth: '010318'}">
          {{ $t('label.system.option.create') }}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
      <!-- 検索パネル -->
      <div class="panel-search">
        <el-form
          :model="query"
          class="search-form"
          label-position="left">

          <!-- タイトル -->
          <div class="fm-row">
            <el-form-item prop="buildingName">
              <el-input maxlength="50" class="fm-input" v-model="query.title"
                :placeholder="$t('label.system.option.title') ">
              </el-input>
            </el-form-item>
          </div>

          <!-- 検索ボタンエリア -->
          <div class="btn-area fm-row">
            <narrow-down @click="SearchBuildReservationOption">
              {{ $t('button.system.owner.search.search') }}
            </narrow-down>
            <cancel-narrow-down class="link-primary margin-left-8" @click="clearSearchParams">
              {{ $t('button.system.building.search.clear') }}
            </cancel-narrow-down>
          </div>
        </el-form>
      </div>

      <!-- ページサイズ選択 -->
      <label v-show="isShow" class="list-title">{{ $t('label.system.option.optionList')  }}</label>
      <div class="st-page-size" v-show="isShow">
        <label class="lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select
          v-model="query.pageSize"
          @change="changePageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>

      <!-- 検索結果テーブル -->
      <div
        ref="searchResultTable"
        id="search-result"
        class="margin-top-28">
        <option-search-result-beautify
          :result="searchResult.body"
          :isShow="this.isShow"
          @on-delete="deleteOption"
          @on-edit="editOption"/>
      </div>

      <br>

      <!-- ページネーション -->
      <pagination
        v-show="searchResult.totalCount > 0"
        :page-size="query.pageSize"
        :page-number="searchResult.pageNumber"
        :totalPage="searchResult.totalPage"
        :totalCount="searchResult.totalCount"
        @on-paging="handlePagingAction" />

    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import optionSearchResultBeautify from "@/components/system/optionSearchResultBeautify"
import SystemManageApi from "@/api/SystemManageApi"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import headTitle from "@/components/common/head/head"
import Pagination from "@/components/common/pagination/Pagination"
import Menubar from "@/components/leftmenu/DashBoard"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import buttonIndex from "@/components/common/sp-smart-button/index";

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE_NUMBER = 1

export default {
  name: "BuildingSearch",
  components: {
    MainLayout: NewDesignLayout,
    optionSearchResultBeautify: optionSearchResultBeautify,
    Pagination: Pagination,
    headTitle: headTitle,
    cancelNarrowDown: cancelNarrowDown,
    narrowDown: narrowDown,
    Menubar: Menubar,
    buttonIndex:buttonIndex
  },
  data() {
    return {
      //照会条件宣言
      query: {
        title: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER
      },
      //結果宣言に戻る
      commonOptionId:null,
      searchResult: {
        pageNumber: 0,
        totalPage: 0,
        totalCount: 0,
        pageSize: 0,
        body: [
          {
            optionId: null,
            optionTitle: null,
            optionRemark: null,
          }
        ]
      },
      options: [
        {
          label: "10件",
          value: 10,
        },
        {
          label: "20件",
          value: 20,
        },
        {
          label: "50件",
          value: 50,
        },
      ],
      isSearching: false,
      tableLoadingAnim: null,
      showSelectOwnerDialog: false,
      buildingId:null,
      isShow: false,
      clickFlag:false
    }
  },
  methods: {
    changePageSize() {
      this.query.pageNumber = 1
      this.SearchBuildReservationOption()
    },
    //検索
    SearchBuildReservationOption () {
      if (!this.isSearching) {
        this.isSearching = true
        this.isShow = true
        this.showTableLoadingAnim()
        this.doneSearchBuildReservationOption()
      }
    },
    doneSearchBuildReservationOption() {
      if(this.commonOptionId == null || this.commonOptionId == ''){
        this.clickFlag = false
      }
      // ビル予約オプション検索
      SystemManageApi.SearchBuildReservationOption({
        keyword: this.query.title,
        buildingId:this.buildingId,
        pageSize: this.query.pageSize,
        pageNumber: this.query.pageNumber
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (statusErrorCodeMsg(data.statusCode, this)) {
            // if(data.body.body > 0 && data.body.body.length == 1 && data.body.body[0].commonFlag){
            //   this.commonOptionId = data.body.body[0].optionId
            //   this.clickFlag = true
            //   this.isSearching = false
            //   this.hideTableLoadingAnim()
            //   return;
            // }
            this.searchResult.pageNumber = data.body.pageNumber
            this.searchResult.totalPage = data.body.totalPage
            this.searchResult.totalCount = data.body.totalCount
            this.query.pageSize = data.body.pageSize
            this.searchResult.body = []
            if(data.body.body != null && data.body.body.length > 0 && data.body.totalCount > 0){
              for (let index of data.body.body) {
                // if(index.commonFlag == false){
                  this.searchResult.body.push({
                    optionId: index.optionId,
                    optionTitle: index.optionTitle,
                    optionRemark: index.optionRemark,
                    commonFlag:index.commonFlag
                  })
                // }
              }
            }
            if(data.body.body.length > 0 && (data.body.body[0].commonOptionId != null && data.body.body[0].commonOptionId != '')){
              this.commonOptionId = data.body.body[0].commonOptionId
            }
            this.clickFlag = true
          }
        }).finally(() => {
          this.clickFlag = true
          this.isSearching = false
          this.hideTableLoadingAnim()
        })
    },
    //クリア
    clearSearchParams () {
      this.query.title = null
      this.query.pageSize = DEFAULT_PAGE_SIZE
      this.query.pageNumber = DEFAULT_PAGE_NUMBER
      this.searchResult.totalPage = 0
      this.searchResult.totalCount = 0
      this.searchResult.body = []
      this.isShow = false
    },

    //削除バータン
    deleteOption (option) {
      this.showTableLoadingAnim()
      SystemManageApi.deleteOption(option.optionId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.deleteSuccess()
          this.SearchBuildReservationOption()
          this.hideTableLoadingAnim()
        })
    },

    //編集バータン
    editOption (option) {
      if(option.commonFlag){
        this.$router.push({
          name: "commonReserveOptipnEdit",
          params: {
            buildingId: this.buildingId
          },
          query: {
            commonFlag:true,
            commonOptionId:this.commonOptionId,
            optionId:null
          }
        })
      }else{
        this.$router.push({
          name: 'reserveOptipnEdit',
          params: {
            buildingId: this.buildingId
          },
          query: {
            commonFlag:false,
            commonOptionId:this.commonOptionId,
            optionId:option.optionId
          }
        })
      }



    },

    //表示テーブルに動画をロードする
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        })
      }
    },

    //隠しフォームロードアニメーション
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close()
        this.tableLoadingAnim = null
      }
    },

    //ページ分け事件を処理する
    handlePagingAction(paging) {
      this.query.pageSize = paging.pageSize
      this.query.pageNumber = paging.pageNumber
      this.SearchBuildReservationOption();
      this.$refs.searchResultTable.scrollIntoView()
    },


    createOption () {
      this.$router.push({
        name: "reserveOptipnCreate",
        params: {
          buildingId: this.buildingId
        },
        query: {
          commonFlag:false,
          commonOptionId:this.commonOptionId,
          optionId:null
        }
      })
    },
    commonOptionEdit(){
      this.$router.push({
        name: "commonReserveOptipnEdit",
        params: {
          buildingId: this.buildingId
        },
        query: {
          commonFlag:true,
          commonOptionId:this.commonOptionId,
          optionId:null
        }
      })
    },
    //削除
    deleteSuccess () {
      this.$messageIotSuccess(this.$t('message.common.delete', {
        field: "予約オプション"
      }));
    },
  },
  watch: {
    query: {
      handler() {
        this.query.pageNumber = 1
      },
      deep: true
    }
  },
  mounted() {
  },
  created() {
    this.$authCheck("010301")
    this.buildingId = this.$route.params.buildingId
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: `/system/buildings/${this.buildingId}/detail`,
        title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.reserveOptionSite",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

    this.searchResult.body = []
    this.SearchBuildReservationOption()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width {
  .my-button {
    width: 188px;
    height: 32px;
  }
}

::v-deep .zdyInput {
  .el-input__inner {
    height: 26px;
    border-radius: 0px !important;
    color: #525250;
    border: 2px solid;
    border-color: #bce0fd;
    font-size: 12px;
  }

  .el-input__inner::placeholder {
    color: #bce0fd;
  }

  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #bce0fd;
  }
}

::v-deep .sp-table-cell {
  color: #6B6B69;
  font-weight: 100;
  font-size: 1px !important;
}

::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #F2F2ED;
}

::v-deep .el-input__suffix {
  top: 0px;
}

::v-deep .el-input__icon {
  line-height: 25px !important;
}

::v-deep .el-form-item__content {
  margin-left: 0em !important;
}

::v-deep .new-input-style-small {
  width: 120px;

  .el-input__inner {
    width: 120px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}

::v-deep .st-page-size label {
  top: 0px;
}

.limit-length {
  width: 100px !important;
}

.edit-btn-style ::v-deep.my-button{
  background: #F2F2ED;
  color: #525250;
}


</style>
